window.UUID = function () {
    return 'xxx-xxxx-xxxx-xxxx'.replaceAll("x", () => Math.floor(Math.random() * 16).toString(16));
};

window.deepClone=function (obj){
    return JSON.parse(JSON.stringify(obj));
}